// src/pages/Public/NotFoundPage.js
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1>404</h1>
        <h2>Sayfa Bulunamadı</h2>
        <p>Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
        <Link to="/" className="not-found-btn">
          Ana Sayfaya Dön
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;